class BaseDocumentaire {

  constructor(){
    this.buttons      = document.querySelectorAll('[data-document-trigger]');
    this.fermers      = document.querySelectorAll('[data-document-close]');
    this.nombreEnfant = 0;
    this._init();
  }

  _init(){
    for(const button of this.buttons){
			button.addEventListener('click', (event)=>this._showAll(event) );
    }
    for(const fermer of this.fermers){
			fermer.addEventListener('click', (event)=>this._colseAll(event) );
    }
  }

  _showAll(event){
    event.preventDefault();
    // on récupère tous les items de la liste correspondant au bouton cliqué
    const listeName = event.currentTarget.getAttribute('data-document-trigger');
    const listItem  = document.querySelectorAll('[data-document-list="'+listeName+'"]');

    // on montre les items
    for(const item of listItem){
			item.setAttribute('data-state','visible');
    }

    // on cache le bouton
    event.currentTarget.setAttribute('data-state','hidden');
  }

  _colseAll(event){
    event.preventDefault();
    // on récupère tous les items de la liste correspondant au bouton cliqué
    const listeName2 = event.currentTarget.getAttribute('data-document-close');
    const listItem2  = document.querySelectorAll('[data-document-list="'+listeName2+'"]');


    // on montre les items
    for(const item2 of listItem2){
      item2.setAttribute('data-state','hidden');
    }

    // on cache le bouton
    event.currentTarget.setAttribute('data-state','hidden');
  }

}

export let baseDocumentaire = new BaseDocumentaire();